import { isEmpty } from "@pathwright/ux/src/components/texteditor/utils"
import { RESOURCE_TYPE_COLLECTION } from "../resource/constants"

export type CoverPageBlankSlateKind =
  | "offer"
  | "pitch"
  | "preview"
  | "overview"
  | "contributors"
  | "categories"

export function getCoverPageContentGaps({
  shortDescription,
  description,
  hasPreviewableSteps,
  resourceType,
  canPreview,
  offers,
  contributors,
  categories
}: {
  shortDescription?: string | null
  description?: string | null
  hasPreviewableSteps: boolean
  resourceType?: number
  canPreview?: boolean
  offers: readonly unknown[]
  contributors: readonly unknown[]
  categories: readonly unknown[]
}): Record<CoverPageBlankSlateKind, boolean> {
  return {
    offer: offers.length === 0,
    pitch: !shortDescription?.trim(),
    preview:
      resourceType === RESOURCE_TYPE_COLLECTION
        ? !canPreview
        : !hasPreviewableSteps,
    overview: isEmpty(description),
    contributors: contributors.length === 0,
    categories: categories.length === 0
  }
}
